"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const location = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-location` : '') + (description ? ` desc-location` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-location"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-location"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.005 0.25C17.3708 0.25 21.38 4.56673 21.38 10.0873C21.38 13.2419 19.6823 16.4423 16.8745 19.5563C15.9073 20.629 14.873 21.6155 13.8385 22.4952L13.5715 22.7197L13.0693 23.1285L12.8356 23.3121L12.4436 23.6084C12.2144 23.7736 11.9152 23.7943 11.6685 23.6703L11.5664 23.6084L11.4493 23.5221L10.9407 23.1285L10.4385 22.7197L10.1715 22.4952C9.13701 21.6155 8.10274 20.629 7.1355 19.5563C4.32767 16.4423 2.63 13.2419 2.63 10.0873C2.63 4.56673 6.6392 0.25 12.005 0.25ZM12.005 1.75C7.49341 1.75 4.13 5.3714 4.13 10.0873C4.13 12.7904 5.66671 15.6874 8.24951 18.5518C9.16899 19.5716 10.1562 20.5132 11.1432 21.3524L11.4795 21.6343L11.6408 21.7666L12.005 22.057L12.4493 21.7012L12.8668 21.3524C13.8538 20.5132 14.841 19.5716 15.7605 18.5518C18.3433 15.6874 19.88 12.7904 19.88 10.0873C19.88 5.3714 16.5166 1.75 12.005 1.75ZM12.005 3.75C15.1797 3.75 17.755 6.32484 17.755 9.5C17.755 12.6752 15.1797 15.25 12.005 15.25C8.83034 15.25 6.255 12.6752 6.255 9.5C6.255 6.32484 8.83034 3.75 12.005 3.75ZM12.005 5.25C9.6587 5.25 7.755 7.15333 7.755 9.5C7.755 11.8467 9.6587 13.75 12.005 13.75C14.3513 13.75 16.255 11.8467 16.255 9.5C16.255 7.15333 14.3513 5.25 12.005 5.25Z",
    fill: "inherit"
  }));
};
var _default = exports.default = location;